<template>
  <v-container class="white--text grid-list-lg Início Login">
    <!-- <SmartBanner/> -->
    <v-layout align-center justify-center row wrap>
      <v-flex xs12 mt5 text-xs-center></v-flex>
    </v-layout>

    <v-layout align-center justify-center row wrap h100 mt5>
      <div class="center-box mt-5">
        <v-flex class="login-box">
          <h1 class="logo">
            <img src="@/assets/img/logo-super-comics.png" v-if="lang === 'pt_BR'" />
            <img src="@/assets/img/logo-super-comics-global.png" v-else />
            <p style="font-weight:300; font-size: 0.9em;" v-html="$t('text.accessTheClubNeo')[2]"></p>
            <!-- p>
              <img src="@/assets/img/logoNeo.png" style="width:30%;"/>
            </!-->
          </h1>
        </v-flex>

        <v-flex class="card pt-3 pb-3 pl-3 pr-3 text-center login-box-card" ref="card">
          <header>
            <h1>{{ $t('title.accessTheClub') }}</h1>
          </header>
          <div card>
            <div class="login-box checkmark-wrap">
              <svg class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
                <circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none" />
                <path class="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8" />
              </svg>
            </div>
          </div>

            <transition name="fade" mode="out-in" tag="v-layout" class="row wrap">
              <v-flex xs12 key="btnSteps">
                <v-layout lang row wrap>
                  <v-flex xs12>
                    <v-text-field
                      v-model="form.email"
                      :label="$t('text.Login')"
                      required
                      outlined
                      autocomplete="nope"
                    ></v-text-field>
                    <v-text-field
                      v-model="form.password"
                      :label="$t('text.Password')"
                      type="password"
                      required
                      outlined
                      autocomplete="nope"
                    ></v-text-field>
                    <v-select
                      class="mt-3"
                      v-model="form.idp"
                      item-value="name"
                      item-text="title"
                      :items="providers"
                      :rules="[v => !!v || 'Item is required']"
                      :label="$t('integration.providers_label')"
                      required
                    ></v-select>
                  </v-flex>
                  <v-flex xs12>
                  <v-btn
                  color="primary"
                  type="submit"
                  @click="login"
                  dark
                  large
                  :loading="sendingForm"
                  :disabled="sendingForm"
                >{{$t('text.next')}}</v-btn>
                  </v-flex>
                </v-layout>
                <v-flex xs12 mt-4>
                  <p class="caption" v-html="$t('text.accessTheClubNeo')[0]"></p>
                  <p class="caption mb-0" v-html="$t('text.accessTheClubNeo')[1]"></p>
                </v-flex>
              </v-flex>
            </transition>

            <dialog-default
              :show="dialog.show"
              :title="dialog.title"
              :message="dialog.message"
              :ok="dialog.ok"
              v-on:close="dialogClose"
            ></dialog-default>
        </v-flex>
      </div>
    </v-layout>
  </v-container>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import Vue from 'vue';
import Vuex from 'vuex';
// import bus from '@/utils/bus';
import DialogDefault from '@/components/dialog/Default';
import axios from 'axios';
// eslint-disable-next-line no-unused-vars
import router from '@/router';
import VueCookies from 'vue-cookies';

Vue.use(Vuex);
Vue.use(VueCookies);

export default {
  components: {
    'dialog-default': DialogDefault
    // SmartBanner
  },
  metaInfo() {
    return {
      title: this.$route.meta.title
        ? 'Super Comics - ' + this.$t(this.$route.meta.title)
        : 'Super Comics'
    };
  },
  data() {
    return {
      dialog: {
        show: false,
        title: '',
        message: '',
        ok: () => {}
      },
      countries: ['+55', '+593', '+965', '+971'],

      form: {
        email:'',
        password:'',
        idp:''
      },

      providers: [],

      sendingForm: false,

      rules: {
        required: v => !!v || this.$t('errors.isRequired')
      },

    };
  },

  mounted() {
    // eslint-disable-next-line no-undef
    axios.defaults.baseURL = __API__;
    axios.defaults.headers.common['api-version'] = '3';
    axios.defaults.headers.common['Content-Type'] = 'application/json';
    axios.defaults.headers.common['Accept-Language'] = 'en-US,en;q=0.5';
    Vue.cookies.remove('sctoken');
    Vue.cookies.set('scloginpage', 'neo');
    this.getIdps();
  },
  computed: {
    lang() {
      const lang = this.$store.getters.lang;
      if (lang === 'pt_BR') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.form.countryCode = '+55';
      } else if (lang === 'es_EC') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.form.countryCode = '+593';
      } else if (lang === 'ar') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.form.countryCode = '+971';
      }
      return lang;
    }
  },
  methods: {
    getIdps(){
      axios.get('/api/idps').then(response=>{
        this.providers = response.data
      }).catch(error=>{
        console.log(error)
      })
    },

    login(){
      let data = {
          flag:'BR',
          email:this.form.email,
          password:this.form.password,
          idp: this.form.idp
      }

      axios.post('/api/new-login',data).then(response => {
        const{token} = response.data
          if (token) {
              Vue.cookies.set('sctoken', response.data.token, '1y');
              this.dialog = {
                show: true,
                title: 'Sucesso',
                message: 'Login efetuado com sucesso',
                ok: () => {
                  this.dialog.show = false;
                }
              };
              this.$router.push('/');
            }
      }).catch(error => {
          const message = error.response
            ? error.response.data.message
            : 'Usuario ou senha ínvalidos. tente novamente!';

          this.dialog = {
            show: true,
            title: 'Erro',
            message: message,
            ok: () => {
              this.dialog.show = false;
            }
          };
      });
    
    
    },
    dialogClose() {
      this.dialog.show = false;
    }
  }
};
</script>
